import { render, staticRenderFns } from "./Footerbar.vue?vue&type=template&id=3b60f544&scoped=true&"
import script from "./Footerbar.vue?vue&type=script&lang=js&"
export * from "./Footerbar.vue?vue&type=script&lang=js&"
import style0 from "./Footerbar.vue?vue&type=style&index=0&id=3b60f544&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b60f544",
  null
  
)

export default component.exports